module.exports = "/_next/static/images/sign-df7679aa8cc19cbe9de1fabe1b39f950.svg";